/* eslint-disable */ 
import React, {useEffect, useState} from 'react';
import './components.css';
import Form from './Form';
import SetRow from './SetRow';
import { Redirect } from 'react-router-dom';
import { useStateValue } from '../ContextApi/StateProvider';

const ExercisePage = (props) => {
    const [errors, setErrors] = useState([]);
    const [exercise, setExercise] = useState({});
    const [sets, setSets] = useState([])
    const [repetitions, setRepetitions] = useState(0);
    const [initialState, dispatch] = useStateValue();
    const authUser = JSON.parse(initialState.authenticatedUser);

    useEffect(()=>{
        initialState.ExerciseRequests.getExercise(
            props.match.params.workoutId,
            props.match.params.id,
            authUser.emailAddress, 
            authUser.password
        ).then(
            response => setExercise(response)
        ).catch(err => {
            console.log('Error' + err);
        })
    }, [])

    useEffect(()=>{
        initialState.SetsRequests.getSets(
            props.match.params.workoutId,
            props.match.params.id,
            authUser.emailAddress,
            authUser.password
        ).then(
            response => setSets(response)
        ).catch(err => {
            console.log('Error ' + err);
        })
    },[])

    const updateSets = () => {
        initialState.SetsRequests.getSets(
            props.match.params.workoutId,
            props.match.params.id,
            authUser.emailAddress,
            authUser.password
        ).then(
            response => setSets(response)
        ).catch(err => {
            console.log('Error ' + err);
        })
    }

    const deleteThisExercise = () => {
        let workoutId = props.match.params.workoutId;
        let id = props.match.params.id;
        if(window.confirm("Are sure you want to delete this exercise? Once deleted, it can not be retrieved.")){
            initialState.ExerciseRequests.deleteExercise(workoutId, id, authUser.emailAddress, authUser.password)
                .then((response) =>{
                    if(response === 'success'){
                        alert("Exercise deleted.")
                        props.history.push(`/workouts/${workoutId}`);
                    } else {
                        props.history.push('/error');
                    }
                }).catch(err => {
                    console.log(err);
                    props.history.push('/error');
                })
        }
    }

    const toEditPage = () => {
        props.history.push(
            `/workouts/${props.match.params.workoutId}/exercises/${props.match.params.id}/edit`
        )
    }

    const change = (event, setState) => {
        const value = event.target.value;
        setState(value);
    }

    const cancel = () => {
        props.history.push(`/workouts/${props.match.params.workoutId}`)
    }

    const submit = () => {
        let workoutId = parseInt(props.match.params.workoutId);
        let exerciseId = parseInt(props.match.params.id);
        const reps = {
            repetitions,
        };
    
        initialState.SetsRequests.createSet(reps, workoutId, exerciseId, authUser.emailAddress, authUser.password)
            .then((response)=> {
                if (response === "success"){
                    console.log(`${authUser.emailAddress} logged set: ${reps}`);
                    updateSets()
                } else if (response === "forbidden") {
                    setErrors([...errors, "You do not have permission to log set."]);
                } else {
                    setErrors([...errors, response])
                    console.log(errors);
                }
            }).catch(err => {
                setErrors([...errors, err])
            })
    }

    const indexArr = sets.map((set, i) => {
        return <SetRow
                    key={i}
                    id={set.id}
                    workoutId={props.match.params.workoutId}
                    exerciseId={props.match.params.id}
                    index={(sets.length) - i}
                    repetitions={set.repetitions}
                    callback={updateSets}
                />
    })

    return (
        authUser ? (
            <div className='excercise-page-container'>
                <div className="container-2025 section-2025 prose-2025">
                    <h2 className='exercise-header'>Exercise: {exercise.title}</h2>
                    <div className='grid-2025'>
                        <div className='edit-button' onClick={toEditPage}>
                            <p>Edit Exercise</p>
                        </div>
                        <div className='delete-button' onClick={deleteThisExercise}>
                            <p>Delete Exercise</p>
                        </div>
                    </div>
                    <div className='excercise-form'>
                        <Form
                            cancel={cancel}
                            cancelButtonText="Back"
                            submit={submit}
                            submitButtonText="Log Set"
                            elements={() => (
                            <React.Fragment>
                                {errors.map((error, i) => <p className='excercise-page-error-message' key={i}>{error}</p>)}
                                <div className='form-row'>
                                    <label className='form-label' htmlFor="repNumber">Enter Repetitions:</label>
                                    <input
                                        className='input-2025'
                                        id="repNumber"
                                        name="repNumber"
                                        type="number"
                                        onChange={(e)=> change(e, setRepetitions)}
                                        required 
                                    />
                                </div>
                            </React.Fragment>
                            )}
                        />
                    </div>
                    {indexArr}
                </div>
            </div>
        ) : (
            <Redirect to="/sign-in" />
        )
    )
}


export default ExercisePage